import React, { useEffect, useRef } from 'react';
import styles from './ScrollProgressBar.module.css';

/**
 * ScrollProgressBar — línea verde fina en el top del viewport que avanza con el scroll.
 * Fusión Monopo: detalle cinético mínimo, acento verde único.
 * rAF-throttled, escala con transform (sin layout thrash).
 */
function ScrollProgressBar() {
  const barRef = useRef(null);

  useEffect(() => {
    let raf = null;

    const update = () => {
      raf = null;
      const el = barRef.current;
      if (!el) return;
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      el.style.transform = `scaleX(${Math.min(Math.max(progress, 0), 1)})`;
    };

    const onScroll = () => {
      if (raf == null) raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      if (raf != null) cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return <div className={styles.track} aria-hidden="true"><div ref={barRef} className={styles.bar} /></div>;
}

export default ScrollProgressBar;
